import { useQuery } from '@tanstack/react-query'
import { reactQueryRequest } from 'api/makeQuery'
import type { Ticket } from 'components/tickets/types'

const useMemberTickets = (memberId: string) => {
  const { data, isLoading, isError, isPlaceholderData } = useQuery<Ticket[]>({
    queryKey: ['memberTickets', memberId],
    queryFn: () =>
      reactQueryRequest('getMemberTickets', {
        memberId,
      }).then((response) => response?.paginated),
    enabled: !!memberId,
  })

  return { memberTickets: data, isLoading, isError, isPlaceholderData }
}

export default useMemberTickets
